<template>
  <footer class="guidance-loop">
    <div class="loop-title">农事指导闭环</div>
    <div class="loop-steps">
      <template v-for="(item, index) in steps" :key="item">
        <span>{{ item }}</span>
        <i v-if="index < steps.length - 1"></i>
      </template>
    </div>
  </footer>
</template>

<script setup>
const steps = ["监测", "分析", "预警", "调控", "反馈", "优化"];
</script>

<style lang="less" scoped>
.guidance-loop {
  position: relative;
  z-index: 1;
  margin: 18px 0 0;
  border: 2px solid rgba(57, 255, 238, 0.7);
  background: linear-gradient(90deg, rgba(0, 107, 91, 0.5), rgba(0, 56, 53, 0.58), rgba(0, 107, 91, 0.5));
  box-shadow: inset 0 0 32px rgba(36, 255, 233, 0.12);
}

.guidance-loop::before,
.guidance-loop::after {
  content: "";
  position: absolute;
  width: 82px;
  height: 34px;
  border-color: #30fff0;
  border-style: solid;
  pointer-events: none;
}

.guidance-loop::before {
  left: -2px;
  top: -2px;
  border-width: 2px 0 0 2px;
}

.guidance-loop::after {
  right: -2px;
  bottom: -2px;
  border-width: 0 2px 2px 0;
}

.loop-title {
  position: absolute;
  top: -33px;
  left: 50%;
  width: 300px;
  height: 58px;
  margin: 0;
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  line-height: 58px;
  text-align: center;
  background: linear-gradient(90deg, transparent, rgba(27, 180, 158, 0.76), transparent);
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.32);
  transform: translateX(-50%);
}

.loop-steps {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.loop-steps span {
  width: 126px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  background: linear-gradient(180deg, rgba(36, 187, 167, 0.95), rgba(8, 126, 115, 0.95));
  border-radius: 4px;
  box-shadow: 0 0 16px rgba(40, 255, 235, 0.16);
}

.loop-steps i {
  width: 48px;
  height: 3px;
  position: relative;
  background: #e9fffd;
  opacity: 0.9;
}

.loop-steps i::after {
  content: "";
  position: absolute;
  right: -2px;
  top: -8px;
  width: 18px;
  height: 18px;
  border-top: 3px solid #e9fffd;
  border-right: 3px solid #e9fffd;
  transform: rotate(45deg);
}
</style>
